// vendor
import styled, { FlattenInterpolation } from "styled-components";
import * as React from "react";
import { CommonBadge } from ".";

interface IProps {
  className?: string;
  overrideStyle?: FlattenInterpolation<any>;
}

// const EMPTY_ARRAY: Moim.Commerce.ICartSellerItem[] = [];
const CartBadge = styled(CommonBadge)<IProps>`
  ${props => props.overrideStyle}
`;

function CartAlertBadge({ className, overrideStyle }: IProps) {
  const count = 0;

  const cartBadgeElement = React.useMemo(() => {
    if (count === 0) {
      return null;
    }

    if (count > 99) {
      return (
        <CartBadge className={className} overrideStyle={overrideStyle}>
          99+
        </CartBadge>
      );
    }

    return (
      <CartBadge className={className} overrideStyle={overrideStyle}>
        {count}
      </CartBadge>
    );
  }, [count, overrideStyle, className]);

  return <>{cartBadgeElement}</>;
}

export default CartAlertBadge;
